<p-dialog [(visible)]="visible" [style]="{minWidth: '600px', maxWidth: '60vw'}" [modal]="true" [draggable]="false"
  [resizable]="false" class="patient-selection-dialog">
  <ng-template pTemplate="header">
    <h4 class="mb-0">{{ 'patient_selection.header' | translate }}</h4>
  </ng-template>
  <div class="grid patient-box">
    <div class="col-12 md:col-6">
      <div class="card">
        <div class="heading font-semibold text-lg default-text-black-color">{{ 'patient_selection.available_patients' |
          translate }}</div>
        <div class="search-box">
          <span class="p-input-icon-right w-full">
            <input pInputText type="text" [(ngModel)]="availablePatientSearch"
              [placeholder]="'patient.lbl_search_by_patient_id' | translate"
              class="mb-2 w-full" />
            @if (availablePatientSearch) {
            <i class="pi pi-times cursor-pointer" (click)="clearAvailablePatientSearch()"></i>
            }
          </span>
        </div>
        @if(filteredAvailablePatients?.length > 0) {
          <p-table [value]="filteredAvailablePatients" [(selection)]="selectedPatients" dataKey="id" [paginator]="true"
            [rows]="10">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 3rem">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>{{ 'patient_selection.patient_id' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-patient>
              <tr>
                <td>
                  <p-tableCheckbox [value]="patient"></p-tableCheckbox>
                </td>
                <td>{{patient.name}}</td>
              </tr>
              <tr>
            </ng-template>
  
          </p-table>
        } @else {
            <div class="w-full">
              <div class="flex flex-column h-27rem surface-200 p-2 justify-content-center align-items-center style-box">
                <div class="m-3">
                  <div class="flex justify-content-center align-items-center">
                    <span><i class="{{miIcons.ARCHIVED_SEARCH}} inline-block wh-80"></i></span>
                  </div>
                  <div class="no-result-div">
                    <p translate>lbl_no_results_to_show</p>
                  </div>
                </div>
                <div class="mb-4">
                  <p class="my-0 pl-3 text-base" translate>no_records_to_show</p>
                </div>
            </div>
          </div>
        }

      </div>
    </div>
    <div class="col-12 md:col-6">
      <div class="card">
        <div class="heading font-semibold text-lg default-text-black-color">{{ 'patient_selection.selected_patients' |
          translate }}</div>
        <div class="search-box">
          <span class="p-input-icon-right w-full">
            <input pInputText type="text" [(ngModel)]="selectedPatientSearch"
              [placeholder]="'patient.lbl_search_by_patient_id' | translate"
              class="mb-2 w-full" />
            @if (selectedPatientSearch) {
            <i class="pi pi-times cursor-pointer" (click)="clearSelectedPatientSearch()"></i>
            }
          </span>
        </div>
        @if (selectedPatientSearch?.length > 0 && filteredSelectedPatients?.length === 0) {
          <div class="w-full">
            <div class="flex flex-column h-27rem surface-200 p-2 justify-content-center align-items-center style-box">
              <div class="m-3">
                <div class="flex justify-content-center align-items-center">
                  <span><i class="{{miIcons.ARCHIVED_SEARCH}} inline-block wh-80"></i></span>
                </div>
                <div class="no-result-div">
                  <p translate>lbl_no_results_to_show</p>
                </div>
              </div>
              <div class="mb-4">
                <p class="my-0 pl-3 text-base" translate>no_records_to_show</p>
              </div>
            </div>
          </div>
        } @else {
          <p-table [value]="filteredSelectedPatients" dataKey="id" [paginator]="true" [rows]="10">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'patient_selection.patient_id' | translate }}</th>
                <th style="width: 20px"></th>
              </tr>
            </ng-template>
          
            <ng-template pTemplate="body" let-patient>
              @if (filteredSelectedPatients?.length > 0) {
              <tr>
                <td>{{patient.name}}</td>
                <td>
                  <i class="pi pi-times-circle cursor-pointer" (click)="removePatient(patient)"></i>
                </td>
              </tr>
              }
            </ng-template>
          </p-table>
        }

      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end flex-wrap btn-with-links m-3">
      <button pButton class="mr-2 bg-white default-text-light-black-color cursor-pointer border-button"
        [label]="'patient_selection.cancel' | translate" (click)="onCancel()"></button>
      <p-button class="flex align-items-center justify-content-center cursor-pointer passenger-box"
        [label]="'patient_selection.save' | translate" (click)="onSave()"></p-button>
    </div>
  </ng-template>
</p-dialog>